export default {"src":"/_next/static/media/security.1a61e16e.svg","height":61,"width":60};